import React, {useState} from "react";
import BookForm from '../bookform/bookform';

const LetsTalk = () => {

    const [showOffcanvas, setShowOffcanvas] = useState(false);

    // Function to toggle Offcanvas visibility
    const toggleOffcanvas = () => setShowOffcanvas(!showOffcanvas);
    
  return (
    <div>
        <div className="d-flex d-md-none justify-content-center align-items-center" id="letsTalkMobileDiv">
            <button onClick={toggleOffcanvas} style={{border:"none", background: "none", borderRadius:"50%"}}>
                <svg id="letsTalkMobile" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <path id="textPath" d="M50 50 m -40, 0 a 40,40 0 1,1 80,0 a 40,40 0 1,1 -80,0" />
                </defs>
                <text fontSize="14" fontWeight="bold" fill="#0000ff">
                    <textPath xlinkHref="#textPath" startOffset="0%">
                    Tap let's talk design .
                    </textPath>
                </text>
                <text fontSize="14" fill="#ffffff">
                    <textPath xlinkHref="#textPath" startOffset="50%">
                    Tap let's talk design .
                    </textPath>
                </text>
                <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="10s"
                    repeatCount="indefinite" />
                </svg>
            </button>
        </div>
        <BookForm showOffcanvas={showOffcanvas} toggleOffcanvas={toggleOffcanvas} />
    </div>
  );
}; 
export default LetsTalk;